// Module
var code = `<mat-dialog-content>
    <div class="hoa-dialog__container">
        <div class="hoa-dialog__header">
            <h1 tid="headerText">Delete Card Confirmation</h1>
        </div>
        <div class="hoa-dialog__main">
            <p tid="paragraphText">Are you sure you want to delete this card from your wallet?</p>
        </div>
        <div class="hoa-dialog__footer" ifOverFlowXClass="hoa-dialog__footer--overflowX">
            <button class="Button Button--link Button--minWidth130"
                    tid="cancel"
                    (click)="closeThisDialog(0)">
                Cancel
            </button>
            <button class="Button Button--blue Button--minWidth130"
                    tid="yes"
                    (click)="closeThisDialog('Delete')">
                Yes
            </button>
        </div>
    </div>
</mat-dialog-content>`;
// Exports
module.exports = code;